import { observer } from "mobx-react";
import React from "react";
import { FieldRenderProps } from "react-final-form";
import { MultiSelectFieldWithAutocomplete } from "../Inputs/SelectField/MultiSelectFieldWithAutocomplete";
import { SelectFieldWithAutocomplete } from "../Inputs/SelectField/SelectFieldWithAutocomplete";
import { ForeignKeyFieldOptions } from "../../index";

export interface ForeignKeyProps
  extends ForeignKeyFieldOptions,
    FieldRenderProps<any> {
  values?: object;
  readOnly?: boolean;
  clearable?: boolean;
}

@observer
export class ForeignKeyComponent extends React.Component<ForeignKeyProps> {
  public render() {
    const { readOnly } = this.props;
    return (
      <>
        {this.props.isMulti ? (
          <MultiSelectFieldWithAutocomplete
            {...this.props}
            options={this.getFilteredList()}
            readOnly={readOnly}
          />
        ) : (
          <SelectFieldWithAutocomplete
            {...this.props}
            options={this.getFilteredList()}
            isDisabled={readOnly}
          />
        )}
      </>
    );
  }

  private getFilteredList = () => {
    let list = [];
    if (this.props.filter && this.props.values) {
      const listToFilter = this.props.dataSource.list;
      const filter = this.props.filter;
      const value = this.props.values[filter];
      for (const item of listToFilter) {
        // using Abstract Equality Comparison on purpose because value may be passed
        // through url and so be in a wrong format
        if (item[filter] == value) {
          list.push(item);
        }
      }
    } else {
      list = this.props.dataSource.list;
    }
    return list;
  };
}
